import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { List } from '@zillow/zrs-cms';
import PropTypes from 'prop-types';
import makeContentInteractive from '../util/makeSpansInteractive.js';
import { usePlacement } from '../components/PlacementProvider/PlacementProvider.js';

var getExtraInstructions = function getExtraInstructions(isPost) {
  return [{
    shouldProcessNode: function shouldProcessNode(node) {
      return node.name === 'ul' || node.name === 'ol';
    },
    processNode: function processNode(node, children, nodeIndex) {
      return /*#__PURE__*/React.createElement(List, _extends({
        key: nodeIndex,
        appearance: node.name === 'ol' ? 'number' : 'bullet'
      }, isPost && {
        paddingBottom: 'sm'
      }), children);
    }
  }, {
    shouldProcessNode: function shouldProcessNode(node) {
      return node.name === 'li';
    },
    processNode: function processNode(node, children, nodeIndex) {
      return /*#__PURE__*/React.createElement(List.Item, {
        key: nodeIndex
      }, children);
    }
  }];
};
var WPList = function WPList(_ref) {
  var innerHTML = _ref.innerHTML;
  var isPost = usePlacement() === 'post';
  var parsedComponent = makeContentInteractive(innerHTML, {
    extraInstructions: getExtraInstructions(isPost)
  });
  return parsedComponent;
};
WPList.propTypes = {
  index: PropTypes.number,
  innerHTML: PropTypes.string
};
var WPList$1 = WPList;

export { WPList$1 as default };
